import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';

import * as beers from '../../../../img/nhl/variants/beers';
import { useTheme } from '../../../contexts/ThemeContext';
import NhlMolsonMvpHorizontal from './NhlMolsonMvpHorizontal';

import styles from '../../../../styles/icons/logos/nhl-mvp-footer.module.scss';

import mvpLogo from '../../../../img/nhl/logo_mvp_horizontal.svg';

const propTypes = {
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

function NhlMolsonMvpFooter({ className }) {
    const { isVariant } = useTheme();
    const { locale } = useIntl();
    const localeBadges = beers[locale];
    const variants = Object.keys(localeBadges);
    // const variant = 'tor';
    const variant = variants.find((it) => isVariant(it)) || null;
    const beer = variant !== null ? localeBadges[variant] : null;
    if (isVariant('normandin')) {
        return (
            <NhlMolsonMvpHorizontal
                className={classNames([
                    styles.normandin,
                    {
                        [className]: className !== null,
                    },
                ])}
            />
        );
    }
    return beer !== null ? (
        <img
            src={beer}
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
            alt="Molson MVP"
        />
    ) : (
        <img
            src={mvpLogo}
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
            alt="Molson MVP"
        />
    );
}

NhlMolsonMvpFooter.propTypes = propTypes;
NhlMolsonMvpFooter.defaultProps = defaultProps;

export default NhlMolsonMvpFooter;
